import React, { useEffect, useState } from 'react';
import axiosInstance from './utils/axiosinstance';
import DropdownMenu from './shared/DropdownMenu';



const VideoDropdown = ( { onSelect }) => {
    const [videos, setVideos] = useState([]);

    const fetchVideos = async () => {
        const response = await axiosInstance.get('/api/fetch_videos/');
        setVideos(response.data.videos);
    };

    useEffect(() => {
        fetchVideos();
    }, []);

    return (
        <DropdownMenu onSelect={onSelect} items={videos} selectText={"Select a video"}/>
    );
}

export default VideoDropdown;
